import BaseService from './base.service'

class ClientService extends BaseService {
    getClient() {
        return new Promise((resolve, reject) => {
            return this.request()
                .post({
                    method: 'Client.getClient',
                })
                .then(response => resolve(response.data?.response))
                .catch(error => reject(this.errorWrapper(error.response)))
        })
    }
}

export default new ClientService()
